export var PregnancyReason = /*#__PURE__*/function (PregnancyReason) {
  PregnancyReason[PregnancyReason["UNPLANNED"] = 1] = "UNPLANNED";
  PregnancyReason[PregnancyReason["INDIFFERENT"] = 2] = "INDIFFERENT";
  PregnancyReason[PregnancyReason["PLANNED"] = 3] = "PLANNED";
  return PregnancyReason;
}(PregnancyReason || {});
export var UnplannedPregnancyCause = /*#__PURE__*/function (UnplannedPregnancyCause) {
  UnplannedPregnancyCause[UnplannedPregnancyCause["UNPROTECTED_SEX"] = 1] = "UNPROTECTED_SEX";
  UnplannedPregnancyCause[UnplannedPregnancyCause["WITHDRAWAL"] = 2] = "WITHDRAWAL";
  UnplannedPregnancyCause[UnplannedPregnancyCause["UNPROTECTED_SEX_GREEN_DAY"] = 3] = "UNPROTECTED_SEX_GREEN_DAY";
  UnplannedPregnancyCause[UnplannedPregnancyCause["CONDOM_FAILURE"] = 4] = "CONDOM_FAILURE";
  UnplannedPregnancyCause[UnplannedPregnancyCause["OTHER_BC_FAILURE"] = 5] = "OTHER_BC_FAILURE";
  UnplannedPregnancyCause[UnplannedPregnancyCause["OTHER"] = 6] = "OTHER";
  return UnplannedPregnancyCause;
}(UnplannedPregnancyCause || {});